import React, { useState } from "react";
import { toast } from "react-toastify";
import { useUpdateFuelTypeMutation } from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";
interface IPROPS {
  closeModal: any;
  refetchingData: any;
  storedData: any;
}

const EditFuelType: React.FC<IPROPS> = ({
  closeModal,
  refetchingData,
  storedData,
}) => {
  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  const [name, setName] = useState(storedData?.type);

  const [
    trigger,
    { isLoading: updatePauseCodeloading, status: updatePauseCodeStatus },
  ] = useUpdateFuelTypeMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const obja = {
      type: name,
    };

    const response = await trigger({ body: obja, id: storedData?.id });

    try {
      if (response?.data) {
        toast.success("Edited successfully");
        closeModal();
        refetchingData();

        setTimeout(() => {}, 3000);
      } else if ("data" in response?.error) {
        const errorData = response?.error?.data as {
          extension: string[];
        };
        const errorMessage = errorData?.extension[0];
        toast.error(errorMessage);

        // setIsButtonDisabled(true);

        // setTimeout(() => {
        //   setIsButtonDisabled(false);
        // }, 3000);
      }
    } catch (error) {
      toast.error("An error occured");

      // setIsButtonDisabled(true);

      // setTimeout(() => {
      //   setIsButtonDisabled(false);
      // }, 3000);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" ,fontFamily:'karbon-medium' }}>
      <div>
        <p
          style={{
            margin: "0",
            fontSize: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          Edit Fuel Type
        </p>
      </div>
      <div>
        <label>Fuel type</label>
        <input
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "10px",
          justifyContent: "end",
        }}
      >
        <button
          type="reset"
          className="btn btn-sm btn-white me-2"
          onClick={() => closeModal()}
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          style={{
            color: `${selectedButtonColors}`,
            background: `${selectedButtonBackgoundColors}`,
            border: "none",
            padding: "10px 15px",
            borderRadius: "20px",
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default EditFuelType;
